module.exports = __webpack_public_path__ + "img/DNADamage-OPSCC_PMID37704757.fe636b17.png";